<template>
  <section class="ai-visibility-detail-intro">
    <div class="ai-visibility-detail-intro__copy">
      <div class="ai-visibility-detail-intro__tag">
        <status-dot status="live" :size="14"/>
        <span>{{ tab.tag }}</span>
      </div>
      <h1>{{ tab.title }}</h1>
      <div class="ai-visibility-detail-intro__main">
        <p>{{ tab.description }}</p>
        <div class="ai-visibility-detail-intro__controls">
          <detail-filters
            :filters="filters"
            :range-options="rangeOptions"
            :model-options="modelOptions"
            @update-filter="$emit('update-filter', $event)"
          />
          <icon-button
            v-if="showManageQuestionsAction"
            :is-leading-icon="true"
            icon="add"
            label="Add questions"
            aria-label="Manage tracked questions"
            @click="$emit('manage-questions')"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DetailFilters from './DetailFilters.vue'
import StatusDot from '../ui/display/StatusDot.vue'
import IconButton from '../ui/controls/IconButton.vue'

export default {
  name: 'DetailIntro',
  components: {
    DetailFilters,
    IconButton,
    StatusDot,
  },
  props: {
    tab: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    rangeOptions: {
      type: Array,
      required: true,
    },
    modelOptions: {
      type: Array,
      required: true,
    },
    showManageQuestionsAction: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-detail-intro {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;
  margin-top: 26px;
}

.ai-visibility-detail-intro__copy {
  width: 100%;
}

.ai-visibility-detail-intro__tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--v-profileAnchorColor-base);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;

  span {
    font-size: 14px;
  }
}

.ai-visibility-detail-intro__main {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin: 14px 0 0;
}

.ai-visibility-detail-intro__controls {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.ai-visibility-detail-intro h1 {
  color: var(--v-mainColor-base);
  font-size: 32px;
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
}

.ai-visibility-detail-intro p {
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.55;
  max-width: 800px;
  margin-bottom: 0;
}

@media (max-width: 860px) {
  .ai-visibility-detail-intro {
    flex-direction: column;
  }

  .ai-visibility-detail-intro__main {
    flex-direction: column;
  }

  .ai-visibility-detail-intro__controls {
    justify-content: flex-start;
    width: 100%;
  }

  .ai-visibility-detail-intro h1 {
    font-size: 26px;
  }
}
</style>
